import {StateChanges} from './stateChanges'
import {RunStates} from './runStates'

function gtag () { window.dataLayer.push(arguments) }

const basicMutations = {
  [StateChanges.SET_ENTIRE_STATE] (state, commitObj) {
    this.replaceState(JSON.parse(commitObj.newStateJson))
  },
  [StateChanges.SEARCH_NOT_RUN]: function (state) {
    state.searchApiState = RunStates.NOT_RUN
  },
  [StateChanges.SEARCH_RUNNING] (state) {
    state.searchApiState = RunStates.RUNNING
  },
  [StateChanges.SEARCH_FAILED]: function (state) {
    state.searchApiState = RunStates.FAILED
  },
  [StateChanges.SEARCH_TIMED_OUT]: function (state) {
    state.searchApiState = RunStates.TIMED_OUT
  },
  [StateChanges.SEARCH_COMPLETE]: function (state) {
    state.searchApiState = RunStates.COMPLETE
  },
  [StateChanges.SET_TEXT_FOR_API_CALL]: function (state, newText) {    
    state.textForApiCall = newText.trim()     
    //var letters = /^[א-ת]+$/;
    //if(!state.textForApiCall.match(letters)) {
    if (/\s/.test(state.textForApiCall)) {  
      state.invalidTerm = true
    } else {
      state.invalidTerm = false
    } 
  },
  [StateChanges.SET_MODE]: function (state, val) {
    state.mode = val
  },
  [StateChanges.SET_NUMBER_OF_WORDS]: function (state, val) {
    state.wordsNum = val
  },
  [StateChanges.SET_SEARCH_RESULTS]: function (state, data) {
    if(state.textForApiCall !== '') {
      gtag('event', 'Word Searched', {
        'event_category': 'selection',
        'event_label': state.textForApiCall
      })
    }
    state.searchApiResponse = data.top_phrases
    state.graphApiResponse = data.graph_html
  },
  [StateChanges.RESET_STATE]: function (state) {    
    state.searchApiResponse = []
    state.textForApiCall = []
    state.graphApiResponse = ''
    state.searchApiState = RunStates.NOT_RUN
    state.textForApiCall = ''
    state.wordsNum = 2
    state.mode = 'tanach'
    window.history.replaceState( {} , '', location.href.split("?")[0] )
  }
  
}

export default basicMutations
